import React from "react";
import { cn } from "@/components/ui/cn";
import { CenterContent, Column, FlexCenterContent, Row } from "@/components/container/Container";

const steps = [
	{ number: 1, label: "Create account" },
	{ number: 2, label: "Finish Setup" },
	{ number: 3, label: "Add Payment" },
	{ number: 4, label: "Invite Team" },
];

const SignUpStepper = ({ currentStep }: { currentStep: number }) => {
	return (
		<Column className="w-[340px] p-7 shrink-0 tablet:w-full tablet:px-8 tablet:pt-0">
			{steps.map((step) => {
				const isFirst = step.number === steps[0].number;
				const isLast = step.number === steps[steps.length - 1].number;
				const isActive = step.number === currentStep;

				const currentStepLine = isActive
					? (<div className="w-[2px] h-[3px] bg-accent60"></div>)
					: (<div className="w-[2px] h-[9px] bg-accent99"></div>);

				const innerCircle = (
					<FlexCenterContent className={cn(
						'h-8 w-8 rounded-[100px] box-content',
						isActive ? 'bg-accent60' : 'bg-accent99',
						isActive && 'border-[4px] border-solid border-white'
					)}>
						<span className={cn(
							'font-poppins text-base font-normal leading-none',
							isActive ? 'text-white' : 'text-primary'
						)}>
							{step.number}
						</span>
					</FlexCenterContent>
				);

				return (
					<Row className="h-[50px] gap-2 items-center">
						<Column className={cn('h-full w-11 items-center', { 'justify-end': isFirst, 'justify-start': isLast })}>
							{!isFirst && currentStepLine}
							{isActive && (
								<FlexCenterContent className={cn('h-11 w-11 rounded-[100px] bg-accent60')}>
									{innerCircle}
								</FlexCenterContent>
							)}
							{!isActive && innerCircle}
							{!isLast && currentStepLine}
						</Column>

						<span className={cn('font-poppins text-base text-primary font-normal', { 'font-medium': isActive })}>
							{step.label}
						</span>
					</Row>
				);
			})}
		</Column>
	);
};

export default SignUpStepper;